export const AgentDesktopPaths = {
    contacts: ["contacts", "contacts/:listId"],
    mySettings: "my-settings",
} as const;
